// extracted by mini-css-extract-plugin
export var blue = "_3x-h";
export var brand = "_3x-d";
export var darkGrey = "_3x-g";
export var disabled = "_3x-6";
export var disabledSubtle = "_3x-7";
export var error = "_3x-8";
export var green = "_3x-i";
export var grey = "_3x-f";
export var icon = "_3x-0";
export var inherit = "_3x-c";
export var lightGrey = "_3x-e";
export var orange = "_3x-k";
export var pink = "_3x-m";
export var primary = "_3x-1";
export var purple = "_3x-n";
export var quaternary = "_3x-4";
export var quinary = "_3x-5";
export var red = "_3x-l";
export var secondary = "_3x-2";
export var success = "_3x-b";
export var tertiary = "_3x-3";
export var warning = "_3x-9";
export var warningSecondary = "_3x-a";
export var white = "_3x-o";
export var yellow = "_3x-j";